import React, { useEffect, useState } from 'react';
import { Select, SelectProps } from 'formik-antd';

type Props = SelectProps;
const StatusSelect = (props: Props): React.ReactElement => {
  const list = [
    { value: 'Complete', display: 'Complete' },
    { value: 'Awaiting information', display: 'Awaiting information' },
    { value: 'On hold', display: 'On hold' },
    { value: 'In progress', display: 'In progress' },
    { value: 'Not started', display: 'Not started' },
  ];
  return (
    <Select {...props}>
      {list.map((item: any): any => (<Select.Option key={item.value} value={item.value}>{item.display}</Select.Option>))}
    </Select>
  );
};

export default StatusSelect;
